import { useTheme } from '@emotion/react';
import { Fragment } from 'react';
import { Link } from '../styled/Link';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import ArrowRightSVG from '../../public/img/angle-right.svg';
import { City } from '../../models';

export function BreadCrumbs({
  items,
  currentCity,
  ...restProps
}: {
  items: Array<{ title: string; url?: string; href?: string }>;
  currentCity: City;
  className?: string;
}) {
  const theme = useTheme();
  return (
    <div
      itemScope
      itemType='https://schema.org/BreadcrumbList'
      css={{
        display: 'flex',
        gap: 16,
        fontsize: 14,
        fontFamily: 'Golos',
        fontWeight: 400,
        a: {
          color: theme.colors.text,
          borderBottom: `1px solid ${theme.colors.text}`,
        },
        textWrap: 'nowrap',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          display: 'none',
        },
        ...restProps,
      }}
    >
      <div
        itemProp='itemListElement'
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <Link itemProp='item' href={['', currentCity.url, ''].join('/')}>
          <span itemProp='name'>Главная</span>
        </Link>
        <meta itemProp='position' content='0' />
      </div>
      {items.map((item, index) => {
        if (index + 1 === items.length) {
          return (
            <Fragment key={index}>
              <div>
                <ArrowRightSVG css={{ width: 5 }} />
              </div>
              <div
                css={{
                  display: 'block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color: '#7D7B7A',
                }}
                itemProp='itemListElement'
                itemScope
                itemType='https://schema.org/ListItem'
              >
                <span itemProp='name'>{item.title}</span>{' '}
                <meta itemProp='position' content={`${index + 1}`} />
              </div>
            </Fragment>
          );
        }

        return (
          <Fragment key={index}>
            <div>
              <ArrowRightSVG css={{ width: 5 }} />
            </div>
            <div
              itemProp='itemListElement'
              itemScope
              itemType='https://schema.org/ListItem'
            >
              <Link
                itemProp='item'
                href={
                  item.href || ['', currentCity.url, item.url, ''].join('/')
                }
              >
                <span itemProp='name'>{item.title}</span>
              </Link>{' '}
              <meta itemProp='position' content={`${index + 1}`} />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
